import { useSelector } from "react-redux";
import { useOrganizationQuery } from "@/shared/hooks/useOrganizationQuery";
import { RootState } from "@/store";

export const useUserData = () => {
  return {
    userOrganizationId: useSelector((state: RootState) => state.session.user?.representative?.organization_id),
    organizationNameFromRedux: useSelector((state: RootState) => state.session.user?.representative?.organization?.name),
    firstName: useSelector((state: RootState) => state.session.user?.representative?.first_name),
    lastName: useSelector((state: RootState) => state.session.user?.representative?.last_name),
    email: useSelector((state: RootState) => state.session.user?.representative?.email),
    avatarUrl: useSelector((state: RootState) => state.session.user?.representative?.avatar?.url),
    roleName: useSelector((state: RootState) => state.session.user?.representative?.representative_role?.name),
  };
};

export const useOrganizationData = (userOrganizationId: string | undefined, organizationNameFromRedux: string | undefined) => {
  const { data: organizationData, isLoading } = useOrganizationQuery(userOrganizationId);

  return {
    organizationData,
    isLoading,
    logo: organizationData?.organization?.logo,
    external_id: organizationData?.organization?.external_id,
    organizationName: organizationData?.organization?.name || organizationNameFromRedux,
  };
};
